import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import Advantages from '../../../../auxiliary-components/shared/AdvantagesBlock';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import { pensionTariffs } from '../../../../services/urls/urls';
import TextBlock from '../../../../auxiliary-components/shared/TextBlock';

export default function template() {
    const page = 'project-support-card-new';

    const hero_data = {
      title: 'PROJECT_SUPPORT_CARD_NEW_HERO_TITLE',
      text: 'PROJECT_SUPPORT_CARD_NEW_HERO_TEXT',
      cards: [
        {
          title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TITLE_01',
          text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TEXT_01',
        },
        {
          title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TITLE_02',
          text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TEXT_02',
        },
        {
          title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TITLE_03',
          text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_HERO_TEXT_03',
        }
      ]
    }

    const advantagesItems = [
      {
        img: advantages_img_1,
        title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TITLE_01',
        text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TEXT_01',
      },
      {
        img: advantages_img_2,
        title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TITLE_02',
        text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TEXT_02',
      },
      {
        img: advantages_img_3,
        title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TITLE_03',
        text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADVANTAGES_TEXT_03',
      }
    ];

    const additionalCards = [
      {
        link: '/services/invite_friend',
        title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_01',
        text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_01',
        textBtn: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_01',
      },
      {
        link: '/cards/atb',
        title: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_02',
        text: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_02',
        textBtn: 'PROJECT_SUPPORT_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_02',
      }
    ];

    const tariffsData = [
      {
        label: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_1_1',
        value: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_1_2',
      },
      {
        label: "PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_2_1",
        value: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_2_2',
      },
      {
        label: "PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_3_1",
        value: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_3_2',
      },
      {
        label: "PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_4_1",
        value: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_4_2',
      },
      {
        label: "PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_5_1",
        value: 'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_CELL_5_2',
      }
    ];

    return (
      <div className="project-support-card-new">
        <Hero
          data={hero_data}
          img={hero_img}
        />
        <div className="content">
          <div>
            <TextBlock text={'PROJECT_SUPPORT_CARD_NEW_TEXT'}/>
            <Advantages
              items={advantagesItems}
              title={'PROJECT_SUPPORT_CARD_NEW_ADVANTAGES_TITLE'}
            />
          </div>
          <Tariffs
            items={tariffsData}
            title={'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_TITLE'}
            btnLink={pensionTariffs}
            btnText={'PROJECT_SUPPORT_CARD_NEW_CARDS_TARIFFS_BTN'}
            page={page}
          />
          <AdditionalProduct
            items={additionalCards}
            title={'PROJECT_SUPPORT_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
            page={page}
          />
          <FilesForDownloadNew
            lang={this.props.lang}
            widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          />
        </div>
      </div>
    );
}
